var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div bb-payment class=\"bb-payment\">\n<iframe id=\"bb-widget-payment\" width=\"100%\" scrolling=\"no\" frameborder=\"0\" ng-src=\"{{url}}\" name=\"payment_form\">\n</iframe>\n<script type=\"text/javascript\">\n$('#bb-widget-payment').iFrameResize({checkOrigin: false, log: false, enablePublicMethods: true});\n</script>\n</div>\n";
var id1="public-booking/payment-button/payment.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/payment-button/payment.html
// module id = 1234
// module chunks = 0